import { render, staticRenderFns } from "./ChipBookType.vue?vue&type=template&id=76a8b72f&"
import script from "./ChipBookType.vue?vue&type=script&lang=js&"
export * from "./ChipBookType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports